// Auth management
export const AUTH_SESSION_TIMEOUT = '/account/session-timeout'
